import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-toolbar2";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import BaoDialog from "./../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import * as moment from "moment";
import Guid from "./../../factories/guid";
import finitoService from "./../../services/finito-service";
import baoRouter from "./../../services/bao-router";
class InformationTab extends SubscriptionViewModel {
    constructor(tabPage: TabPage, parent: any) {
        super(tabPage);
        this.TabPage = tabPage;
        this.ShiftReport = parent;
        this.OriginalTabTitle = this.TabPage.Title();
        this.TotalRows.subscribe((value) => {
            if (value == null || value == 0) {
                this.TabPage.Title(this.OriginalTabTitle);
                return;
            }
            this.TabPage.Title(this.OriginalTabTitle + " (" + value + ")");
        });
        this.PageIndex.subscribe(() => {
            this.getInfos();
        });
        this.PageSize.subscribe(() => {
            if (this.PageIndex() === 0) {
                this.getInfos();
            }
            else {
                this.PageIndex(0);
            }
        });
        this.ShowDeletedInfos.subscribe(() => {
            this.CustomFilter().IncludeDeleted = this.ShowDeletedInfos();
            this.getInfos();
        });
    }
    TabPage;
    BaoRouterSubscriptions = [];
    Bao = Bao;
    ShiftReport;
    ValidDateJs = ko.observable(moment().format(Bao.Utils.DateTimeFormat));
    Columns = ko.observableArray([]);
    TagColumns = ko.observableArray([]);
    Infos = ko.observableArray([]);
    TagValues = ko.observableArray([]);
    SystemSettingNotifyWhenAddEventToClosedReport = ko.observable(false);
    ShowUniversalfields = ko.observable(false);
    PageSize = ko.observable(10);
    PageIndex = ko.observable(0);
    Sorting = ko.observableArray();
    Selection = ko.observableArray<any>();
    CustomFilter = ko.observable<any>({});
    TotalRows = ko.observable(0);
    OriginalTabTitle;
    // Toolbar-LoadedHandler
    toolbarLoaded = (buttons) => {
        this.toggleButtons();
    };
    // checkbox to see deleted informations
    ShowDeletedInfos = ko.observable(false);
    showShowDeletedCheckbox = ko.observable(false); // show the checkbox only if the user has permissions
    // Toolbar-ClickHandler
    toolbarButtonClicked = (btn) => {
        if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
            var actionFormName = 'action' + this.ShiftReport.FormName() + 'CustomToolbarInfo';
            var functionString = btn.ActionKey().substr(actionFormName.length);
            if (functionString && $.isFunction(this[functionString.toLowerCase()])) {
                this[functionString.toLowerCase()]();
            }
        }
    };
    returnToMythis = (tabToClose) => {
        if (tabToClose) {
            this.ShiftReport.TabViewModel.RemoveTab(tabToClose);
            this.ShiftReport.TabViewModel.SelectTab(this.TabPage);
        }
    };
    link = (index, infoModel) => {
        if (infoModel) {
            this.edit(infoModel.InfoId(), index(), null);
        }
    };
    getTagValue = (tagId, infoId) => {
        var tagValues = this.TagValues();
        for (var n = 0; n < tagValues.length; n++) {
            if (tagValues[n].InfoId() === infoId && tagValues[n].TagId() === tagId) {
                return tagValues[n].TagValueHtml();
            }
        }
        return "";
    };
    init = () => {
        this.TabPage.IsLoading(true);
        this.TabPage.IconLeft("fal fa-dot-circle");
        this.showShowDeletedCheckbox(Bao.Session.HasPermission("ShowDeletedInfos", "E08AA793-C9AD-4C68-BF21-06014EA951A3"));
        return $.when(this.getColumns(), this.getTagColumns(), this.getTagValues()).then(() => this.getInfos());
        //return this.getInfos();
    };
    getNavigation = (validDate) => { };
    loaded = () => {
        var def = $.Deferred();
        // Route für Info auslesen (infoid)
        this.BaoRouterSubscriptions.push((<any>baoRouter).routed((request, data) => {
            this.routeToInfo(request);
        }));
        this.routeToInfo(this.ShiftReport.TabPage);
        Bao.bindEvent('informations:refresh', (value) => {
            if (value.ReportId == this.ShiftReport.ReportId()) {
                this.getInfos();
            }
        });
        this.ValidDateJs.subscribe((validDateJs) => {
            this.getNavigation(validDateJs);
        });
        this.subscribe(this.ShiftReport.IsOriginal, (isOriginal) => {
            this.TabPage.IsLoading(true);
            this.getInfos().then(() => {
                this.TabPage.IsLoading(false);
                this.toggleButtons();
            });
        });
        this.subscribe(this.Sorting, () => {
            this.resetSearchPaging();
            this.getInfos();
        });
        this.subscribe(this.CustomFilter, () => {
            this.resetSearchPaging();
            if (this.PageIndex() === 0) {
                this.getInfos();
            }
            else {
                this.PageIndex(0);
            }
        });
        this.subscribe(this.Selection, (selection) => {
            this.toggleButtons();
        });
        this.TabPage.IsLoading(false);
        def.resolve();
        return def.promise();
    };
    dispose() {
        ko.utils.arrayForEach(this.BaoRouterSubscriptions, (subscription) => {
            (<any>baoRouter).unsubscribe(subscription);
        });
        ko.utils.arrayForEach(this.Subscriptions, (subscription: any) => {
            subscription.dispose();
        });
    }
    ;
    ToHashObject = (customFilter) => {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    };
    // InfoId aus der Route entfernen
    removeInfoIdFromRoute = () => {
        var currentHash = baoRouter.getHash(), infoIdIndex = currentHash.toLowerCase().indexOf('info');
        if (infoIdIndex !== -1) {
            baoRouter.replaceHash(currentHash.substr(0, infoIdIndex));
        }
    };
    /// Route zur Info
    routeToInfo = (tabPage) => {
        if (this.TabPage.IsActiveTab()) {
            var reportId = baoRouter.getRouteValue('id', tabPage);
            if (reportId === this.ShiftReport.ReportId()) {
                var infoId = baoRouter.getRouteValue('infoid', tabPage);
                if (infoId) {
                    this.removeInfoIdFromRoute();
                    var activeInfoTab = this.ShiftReport.TabViewModel.SearchTabByObjectId('ActiveInfo');
                    var index = null, i = 0, ignoreIndex = true;
                    ko.utils.arrayForEach(this.Infos(), (item: any) => {
                        if (item.InfoId() == infoId) {
                            ignoreIndex = false;
                            index = i;
                        }
                        i++;
                    });
                    if (activeInfoTab) {
                        if (ko.isObservable(activeInfoTab.ViewModel)) {
                            var infoViewModel = activeInfoTab.ViewModel();
                            if (infoViewModel) {
                                if (infoViewModel.InfoId() !== infoId) {
                                    //this.createNewInfoTab();
                                    this.edit(infoId, index, ignoreIndex);
                                }
                            }
                        }
                    }
                    else {
                        //this.createNewInfoTab();
                        this.edit(infoId, index, ignoreIndex);
                    }
                }
            }
        }
    };
    resetSearchPaging = () => {
        var activeInfoTab = this.ShiftReport.TabViewModel.SearchTabByObjectId('ActiveInfo');
        if (activeInfoTab) {
            activeInfoTab.ViewModel().disablePaging();
        }
    };
    getColumns = () => {
        this.TabPage.IsLoading(true);
        return Bao.post('Information/GetAllColumns', JSON.stringify({
            reportId: this.ShiftReport.ReportId()
        })).then(result => {
            this.Columns(result);
        });
    };
    getTagColumns = () => {
        this.TabPage.IsLoading(true);
        return Bao.post('Information/GetTagColumns', JSON.stringify({
            reportId: this.ShiftReport.ReportId()
        })).then(result => {
            this.ShowUniversalfields(result.ShowUniversalfields);
            this.TagColumns(result.TagColumns);
        });
    };
    getTagValues = () => {
        this.TabPage.IsLoading(true);
        return Bao.post('Information/GetTagValuesByReport', JSON.stringify({
            reportId: this.ShiftReport.ReportId(),
            isOriginal: this.ShiftReport.IsOriginal.peek(),
            customFilter: this.ToHashObject(ko.unwrap(this.CustomFilter))
        })).then(result => {
            this.TagValues(result);
        });
    };
    //
    // Fetch Informationen
    getInfos = () => {
        this.TabPage.IsLoading(true);
        var customFilter = this.ToHashObject(ko.unwrap(this.CustomFilter));
        return Bao.post('Information/GetAll', JSON.stringify({
            id: this.TabPage.FormHistoryId,
            reportId: this.ShiftReport.ReportId(),
            searchFilter: {
                IsOriginal: this.ShiftReport.IsOriginal.peek(),
            },
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customfilter: customFilter
        })).then((result) => {
            ko.map.fromJS(result, this);
            if (this.Infos != undefined) {
                ko.utils.arrayForEach(this.Infos(), (item: any) => {
                    if (item.DeleteDate() == null) {
                        item.ShowDeletedInfosStyle("none");
                    }
                    else {
                        item.ShowDeletedInfosStyle("line-through");
                    }
                });
            }
            this.TabPage.IsLoading(false);
        });
    };
    enableButton = (actionKey, enabled) => { };
    // Ein-/Ausblenden der Buttons
    toggleButtons = () => {
        var prefix = 'action' + this.ShiftReport.FormName() + 'CustomToolbarInfo';
        var hasSelection = this.Selection().length > 0;
        this.enableButton(prefix + 'New', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek());
        this.enableButton(prefix + 'Edit', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'Copy', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'BlindCopy', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'CreateNotification', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'CreateChecklist', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'CreateTicket', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'Delete', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsClosed.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
    };
    // Tab für aktive Information erstellen
    createNewInfoTab = () => {
        var newTab = this.ShiftReport.TabViewModel.SearchTabByObjectId('ActiveInfo');
        if (!newTab) {
            newTab = new TabPage('ActiveInfo');
            newTab.AutoSelect = false;
            newTab.Url('Information/Detail');
            newTab.UrlData({
                id: this.TabPage.FormHistoryId,
                reportId: this.ShiftReport.ReportId(),
                shiftbookId: this.ShiftReport.ShiftbookId()
            });
            newTab.IsClosable(true);
            newTab.PreLoad(true);
            newTab.Visible(true);
            newTab.FormHistoryId = this.TabPage.FormHistoryId;
            newTab.InformationTab = this;
            newTab.AlreadyLoaded = false;
            this.ShiftReport.TabViewModel.AddTab(newTab);
        }
        return newTab;
    };
    // Aktueller geöffneter Informations-Tab
    getInfoTab = () => {
        return this.ShiftReport.TabViewModel.SearchTabByObjectId('ActiveInfo');
    };
    // Information erstellen
    ['new'] = () => {
        if (!this.SystemSettingNotifyWhenAddEventToClosedReport() || this.ShiftReport.IsClosed() !== true) {
            this.OpenNewShiftEvent();
            return;
        }
        // report is closed and system-setting for prompt is set to true, so ask if user really wants to add an info to a closed report
        var yesnodialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.AddEventToClosedReport), 'yesno');
        yesnodialog.DialogResult.subscribe(function (dialogresult) {
            if (dialogresult) {
                this.OpenNewShiftEvent();
                return;
            }
        });
    };
    OpenNewShiftEvent = () => {
        var infoTab = this.createNewInfoTab();
        if (infoTab) {
            var newInfoId = Guid();
            infoTab.InfoId = newInfoId;
            infoTab.IsNew = true;
            this.loadTab(infoTab, true, newInfoId, null);
        }
    };
    // Information für Paging ermitteln
    GetInfoForPaging = (index) => {
        var def = $.Deferred();
        var indexFrom = this.PageIndex() * this.PageSize();
        var indexTo = indexFrom + this.PageSize() - 1;
        if (index >= indexFrom && index <= indexTo) {
            var currentRowIndex = index - this.PageIndex() * this.PageSize();
            def.resolve(this.Infos()[currentRowIndex]);
        }
        else {
            var customFilter = this.ToHashObject(ko.unwrap(this.CustomFilter));
            Bao.post("Information/GetAll", JSON.stringify({
                id: this.TabPage.FormHistoryId,
                reportId: this.ShiftReport.ReportId(),
                searchFilter: {
                    IsOriginal: this.ShiftReport.IsOriginal.peek(),
                },
                pageIndex: index,
                pageSize: 1,
                sorting: this.Sorting(),
                customfilter: customFilter
            }), (searchResult) => {
                if (searchResult != null && searchResult.Infos != null) {
                    def.resolve(searchResult.Infos[0]);
                }
                else {
                    def.resolve(null);
                }
            });
        }
        return def.promise();
    };
    // Information bearbeiten
    edit = (infoId, index, ignoreIndex) => {
        if (infoId == null || (index == null && ignoreIndex == false)) {
            if (this.Selection().length > 0) {
                if (infoId == null) {
                    infoId = this.Selection()[0].InfoId();
                }
                if (index == null) {
                    var i = 0;
                    ko.utils.arrayForEach(this.Infos(), (item) => {
                        if (item.InfoId() == infoId) {
                            index = i;
                        }
                        i++;
                    });
                    if (index == null) {
                        //Server roundtrip?
                    }
                }
            }
            else {
                return;
            }
        }
        if (index != null) {
            index = index + (this.PageIndex() * this.PageSize());
        }
        var tabAlreadyOpened = this.ShiftReport.TabViewModel.SearchTabByObjectId('ActiveInfo') != null;
        var infoTab = this.createNewInfoTab();
        if (infoTab) {
            if (tabAlreadyOpened == false) {
                infoTab.IsNew = false;
                infoTab.InfoId = infoId;
                infoTab.ListIndex = index;
            }
            this.loadTab(infoTab, false, infoId, index);
        }
    };
    // Information laden
    loadTab = (tab, isNew, infoId, listIndex) => {
        this.ShiftReport.TabViewModel.SelectTab(tab);
        if (tab.AlreadyLoaded) {
            var tabViewModel = tab.ViewModel();
            //isNew = tab.IsNew, // Tab-Daten zwischenspeichern, da der aktuell offene Tab evtl. noch gespeichert wird und die Daten überschreibt
            //infoId = tab.InfoId,
            //listIndex = tab.ListIndex;
            tabViewModel.BeforeClose(() => {
                tab.IsNew = isNew;
                tab.InfoId = infoId;
                tab.ListIndex = listIndex;
                tabViewModel.init().then(tabViewModel.loaded).then(() => {
                    tabViewModel.PagingEnabled(true);
                    this.ShiftReport.TabViewModel.SelectTab(tabViewModel.TabPage);
                    tabViewModel.toggleButtons();
                    tabViewModel.setTabTitle();
                });
            }, true);
        }
        else {
        }
    };
    copy = () => {
        //entfällt
    };
    // Information an kommende Schicht weiterleiten
    blindcopy = () => {
        var selection = this.Selection();
        if (selection.length > 0) {
            var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InfoBlindCopyQuestion), 'yesno');
            dialog.DialogResult.subscribe((canCopy) => {
                if (canCopy) {
                    this.TabPage.IsLoading(true);
                    var infoIds = ko.utils.arrayMap(selection, (i) => {
                        return i.InfoId();
                    });
                    Bao.post('Information/BlindCopy', JSON.stringify({
                        id: this.TabPage.FormHistoryId,
                        reportId: this.ShiftReport.ReportId(),
                        infoIds: infoIds
                    })).then((copied) => {
                        this.Selection([]);
                        if (copied) {
                            this.showAlert(finitoService.MessageKeys.InfoBlindCopySuccessful);
                        }
                        else {
                            this.showAlert(finitoService.MessageKeys.InfoBlindCopyError, 'danger');
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    // Information löschen
    ["delete"] = () => {
        var selection = this.Selection();
        if (selection.length > 0) {
            var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InfoDeleteQuestion), 'yesno');
            dialog.DialogResult.subscribe((canDelete) => {
                if (canDelete) {
                    this.TabPage.IsLoading(true);
                    var infoIds = ko.utils.arrayMap(selection, (i) => {
                        return i.InfoId();
                    });
                    Bao.post('Information/Delete', JSON.stringify({
                        id: this.TabPage.FormHistoryId,
                        reportId: this.ShiftReport.ReportId(),
                        infoIds: infoIds
                    })).then((deleted) => {
                        this.Selection([]);
                        if (deleted > 0) {
                            var infoTab = this.getInfoTab();
                            if (infoTab) {
                                if (infoTab.ViewModel().InfoId() == infoIds[0]) {
                                    this.ShiftReport.TabViewModel.RemoveTab(infoTab);
                                }
                            }
                            this.showAlert(finitoService.MessageKeys.InfoDeleteSuccessful);
                        }
                        else {
                            this.showAlert(finitoService.MessageKeys.InfoDeleteError, 'danger');
                        }
                        this.getInfos();
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    // Schichtinformation an SAP-PM melden 
    createnotification = () => {
        var selection = this.Selection();
        if (selection.length > 0) {
            this.TabPage.IsLoading(true);
            var infoId = this.Selection()[0].InfoId();
            var notifCreated = false;
            return Bao.post("Information/CheckInfoSap", JSON.stringify({
                infoId: infoId
            }), (result) => {
                notifCreated = result.Message;
                if (!notifCreated) {
                    this.TabPage.IsLoading(true);
                    window.baorequire(['ViewModels/Dialogs/InfoSapDialog'], (vm) => {
                        var dialog;
                        if (infoId != null) {
                            dialog = new vm(this.TabPage);
                            dialog.Show(infoId, this.TabPage);
                            this.TabPage.IsLoading(false);
                        }
                    });
                }
                else {
                    var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSapExist"), "info");
                }
                this.TabPage.IsLoading(false);
            });
        }
    };
    createchecklist = () => {
        var selection = this.Selection();
        if (selection.length > 0) {
            var count = 0;
            return Bao.post("Dialog/GetInfoChecklistsByShiftbookId", JSON.stringify({
                shiftbookId: this.ShiftReport.ShiftbookId()
            }), (result) => {
                if (result != null) {
                    count = result.length;
                }
                if (count === 1) {
                    this.CreateEvaluation(result[0], this.ShiftReport.ReportId());
                }
                else {
                    window.baorequire(['ViewModels/Dialogs/CreateEvaluationDialog'], (vm) => {
                        var dialog = new vm(this.TabPage, this);
                        dialog.Show();
                        dialog.DialogResult.subscribe((dialogResult) => {
                            if (dialogResult == true) {
                                this.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), this.ShiftReport.ReportId());
                            }
                        });
                    });
                }
            });
        }
    };
    CreateEvaluation = (folderStructureChecklistId, reportId) => {
        this.TabPage.IsLoading(true);
        var infoId = this.Selection()[0].InfoId();
        //TODO
        return Bao.post("EvaluationTab/CreateEvaluationByReport", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            reportId: reportId,
            infoId: infoId
        }), (result) => {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            this.TabPage.IsLoading(false);
        });
    };
    createticket = () => {
        var selection = this.Selection();
        if (selection.length > 0) {
            var infoId = selection[0].InfoId();
            // Load InfoModel
            Bao.post('Information/GetInformation', JSON.stringify({
                reportId: this.ShiftReport.ReportId(),
                infoId: infoId,
                isOriginal: false
            }), (result) => {
                window.location.hash = "#/ticket/problem/" + result.InfoText + "/info/" + result.InfoId;
            });
        }
        ;
    };
}
export default InformationTab;